import React from 'react';
import theme from 'assets';
import { Results } from './components';
import { Grid, Typography } from '@mui/material';


let CountryTaxRate = () => {

    return (
        <div style={{ padding: theme.spacing(2) }}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h4">Countries tax rates</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Results />
                </Grid>
            </Grid>
        </div>
    );
}

export default CountryTaxRate;